<template>
  <div>
    <div class="notification is-warning is-marginless">
      <p class="is-uppercase is-size-7">
        <span>LES ÉVÈNEMENTS VIENNENT NOURRIR LE FIL D’ACTUALITÉ DE TOUS LES ESPACES ACQUÉREURS DE CE PROGRAMME. LES ÉVÈNEMENTS SERONT NOTIFIÉS AUTOMATIQUEMENT AUX ACQUÉREURS.</span>
      </p>
    </div>
    <div
      v-if="timeline.length"
      class="has-background-white">
      <button
        class="page-header-btn button is-dark is-fullwidth is-radiusless"
        @click="openModalEvent">
        <span>CRÉER UN NOUVEAU POST</span>
      </button>
      <div class="column is-padding-right is-padding-left is-paddingless-top">
        <div class="timeline is-centered">
          <template v-for="(event, index) in orderedTimeline">
            <time-line-event
              :key="index"
              :id="program.pk"
              :from="'programs'"
              :event="event"
              @sliceEvent="sliceEvent"></time-line-event>
          </template>
        </div>
      </div>
    </div>
    <div
      v-else
      class="is-margin is-border is-padding">
      <div class="columns">
        <div class="column is-6 has-text-centered">
          <img
            src="/img/Groupe-14876.svg"
            alt="">
        </div>
        <div class="column is-6">
          <div class="title is-2 has-text-weight-medium is-margin-bottom-small">
            Créez votre premier post pour communiquer avec vos acquéreurs
          </div>
          <div class="">
            Informer vos clients sur l’actualité de votre programme
          </div>
          <div
            class="has-background-dark is-w64p is-margin-top-small"
            style="height: 2px;"></div>
          <p class="is-size-6 is-padding-top-small">
            Vos clients sont en attente d’information en rapport avec leur projet de logement. En quelques clic postez photos et documents qui leur sont destinés. Tous les acquéreurs seront automatiquement notifiés par mail.
          </p>
          <b class="is-size-6">Vous communiquez plus, vos client aiment !</b>
          <div class="is-margin-top">
            <a
              @click="openModalEvent()"
              type="button"
              class="button is-success is-minW260p">
              CRÉER VOTRE PREMIER POST
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { orderBy } from 'lodash'

export default {
  name: 'BuyerSpaceTimeline',
  components: {
    TimeLineEvent: () => import('../utils/TimeLineEvent')
  },
  props: {
    program: {
      type: Object
    },
    timeline: {
      type: Array
    }
  },
  computed: {
    ...mapState(['modal']),
    orderedTimeline () {
      return orderBy(this.timeline, x => {
        return x.date
      }, 'desc')
    }
  },
  watch: {
    modal ({ mode, params, results }) {
      if (results) {
        if (mode === 'EVENT_MODAL') {
          if (params.id === this.program.pk) {
            let idx = this.timeline.findIndex(x => {
              return x.pk === results.pk
            })
            this.$emit('updateTimeline', idx, results)
          }
        }
      }
    }
  },
  methods: {
    sliceEvent (pk) {
      this.$emit('sliceEvent', pk)
    },
    /**
       * open event modal
       */
    openModalEvent () {
      let params = {
        id: this.program.pk,
        from: 'programs'
      }
      this.$store.commit('setModal', { mode: 'EVENT_MODAL', params })
    }
  }
}
</script>
